import { render, staticRenderFns } from "./select-doctors.vue?vue&type=template&id=0c6269f7&scoped=true&lang=pug&"
import script from "./select-doctors.vue?vue&type=script&lang=ts&"
export * from "./select-doctors.vue?vue&type=script&lang=ts&"
import style0 from "./select-doctors.vue?vue&type=style&index=0&id=0c6269f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6269f7",
  null
  
)

export default component.exports